import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { Link, redirect, useParams } from "react-router-dom";
import { Footer, Navbar } from "../components";
import axios from "axios";
import configData from "../config.json";
import {format, formatDate} from "date-fns";
import { useNavigate } from "react-router-dom";

const SuccessOrder=()=>{

    const [token, setToken] = useState('');
    // const [ready, setReady] = useState(false);
    const [order, setOrder] = useState('');

    const fetchDetails = async () => {
        const urlSearchString = window.location.search;
       
        const params = new URLSearchParams(urlSearchString);
      
       
        setToken(params.get('Token'));

        if(params.get('Mode')=='success'){

            const response=await axios.get(configData.SERVER_URL+'/orderVerify/'+params.get('Token'));

            // console.log(response);

            if(response.data.Status===200){
            
                setOrder(await response.data);
                 
            } else {
            window.location.replace(configData.ResponseUrl);
            } 
        } else {
            window.location.replace(configData.ResponseUrl);
        } 

    }

    useEffect(( ) => {

        fetchDetails();     
       
        // setReady(true);
       
    }, [ ]);

    const backToShop=()=>{
        window.location.replace(configData.ResponseUrl);
    }


    return(
        <>
        {/* <Navbar/> */}
        <div className="container  my-3 py-3" >
            <hr/>  
            <div className="row col-8"> 
            <div className="card mb-4 ">
                <div className="card-header py-3 text-center">
                    <img className="" src={configData.IMAGE_URL+"/bseceshop.png"} width={100}/>
                    <h4 className="mb-0" style={{color:'green'}}>Thank You for Shopping</h4>
                </div>
                <div className="card-body">
                    <label>{order.Message}</label>
                    <hr/>
                    <label>Transaction ID :{order.TransactionId}</label>
                    <hr/>
                    <label>Transaction Date :{order.TransactionDate}</label>
                    <hr/>
                    <label>Paid Amount : {order.CustomerPaidAmount}</label>
                    <hr/>
                    <label>Customer Name: {order.CustomerName}</label>
                </div>
            </div>  
            </div>

            <div className="row col-4 text-center">
                <a className="btn btn-info" href={order.VoucherLink}>download voucher</a>
                <button className="w-20 btn btn-success" onClick={() => backToShop()}>
                    Back to Shop
                </button>    
            </div>              
        </div>
        <Footer/>
        </>
    ) 
}

export default SuccessOrder;